import { defineNuxtPlugin } from '#app'
import { openDB, type IDBPDatabase } from 'idb'
import type { AppDBSchema } from '~/types/database'

import UploadDbModule from '~/repository/database/modules/upload'

interface IDatabaseInstance {
    upload: UploadDbModule
}

export default defineNuxtPlugin((nuxtApp) => {
    // Mantém a instância do DB em memória (Singleton)
    let dbInstance: IDBPDatabase<AppDBSchema> | null = null;

    // Função "preguiçosa" para pegar/iniciar o DB apenas quando requisitado
    const getDb = async () => {
        if (!dbInstance) {
            dbInstance = await openDB<AppDBSchema>('IcatuCoreDB', 1, {
                upgrade(db) {
                    // Tabela de Sessões
                    if (!db.objectStoreNames.contains('sessions')) {
                        db.createObjectStore('sessions', { keyPath: 'uploadId' });
                    }
                    // Tabela de Chunks
                    if (!db.objectStoreNames.contains('chunks')) {
                        const chunkStore = db.createObjectStore('chunks', { keyPath: 'id' });
                        // Cria um índice para buscarmos os chunks pelo uploadId de forma rápida
                        chunkStore.createIndex('by-uploadId', 'uploadId');
                    }
                },
                terminated() {
                    // Conexão foi fechada externamente — descartar singleton para reabrir na próxima chamada
                    dbInstance = null;
                },
            });
        }
        return dbInstance;
    };

    // Instancia os módulos passando o getDb
    const modules: IDatabaseInstance = {
        upload: new UploadDbModule(getDb),
    }

    return {
        provide: {
            indexdb: modules
        }
    }
})

// === Injeção de Tipos Globais ===

declare module '#app' {
    interface NuxtApp {
        $indexdb: IDatabaseInstance
    }
}

declare module 'vue' {
    interface ComponentCustomProperties {
        $indexdb: IDatabaseInstance
    }
}